var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWithOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1403 0.293677C13.9445 0.0990266 13.6275 0.0996623 13.4324 0.295096L6.2469 7.49334C6.18707 7.55327 6.14348 7.62739 6.12021 7.70873L5.40723 10.2016C5.36404 10.3526 5.50431 10.492 5.65548 10.4483L8.15103 9.72689C8.23247 9.70335 8.30657 9.65955 8.3664 9.59962L13.6415 4.31521L11.5309 2.20459L12.238 1.49749L14.348 3.60748L15.5519 2.40138C15.747 2.20594 15.7464 1.88972 15.5505 1.69507L14.1403 0.293677Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V13.9C14 13.9552 13.9552 14 13.9 14H2.1C2.04477 14 2 13.9552 2 13.9V2.1C2 2.04477 2.04477 2 2.1 2H8",
    stroke: "#585D66",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWithOutlineIcon);
export default __webpack_public_path__ + "static/media/edit-with-outline-icon.d79116368d9a6095205df06e0f5624ac.svg";
export { ForwardRef as ReactComponent };